import React from "react";
import Header from "../Components/Header/header";
import HotBar from "../Components/HotBar/hotBar";

function ContactsPage() {
  return (
    <>
      <Header />
      <HotBar />
    </>
  );
}

export default ContactsPage;
